/**
 * Created by ivo on 01.08.14.
 */
define([
    'jQuery',
    'underscore',
    'library/fcse-compatibility/object',
    'library/fcse-component/optionsMixin',
    'library/fcse-events/eventDispatcher'
],
    function($, _, Object, OptionsMixin, EventDispatcher) {

        var FavoritesHandler = function(requestHandler, options) {
            EventDispatcher.apply(this, arguments);

            // Set default options
            var defaultOptions = {
                buttonActiveClass: 'is-active',
                addRoute: 'allt_frontend.favorites.add',
                removeRoute: 'allt_frontend.favorites.remove',
                countRoute: 'allt_frontend.favorites.count',
                favoriteAddButtonSelector: '[data-fcse-role="favorites--add"]',
                favoriteCountSelector: '[data-fcse-role="favorites--count"]',
                favoriteRemoveButtonSelector: '[data-fcse-role="favorites--remove"]',
                favoriteIdAttribute: 'data-favorites-id'
            };

            // Save local variables
            this.requestHandler = requestHandler;

            this.addOptions(defaultOptions, options);

            // Register events
            this.registerEvent("remove");
            this.registerEvent("add");

            this._init();
            this._initLoadingEvents();
            this._updateCount();
        };

        FavoritesHandler.prototype = $.extend(Object.create(EventDispatcher.prototype), Object.create(OptionsMixin),{
            /**
             * Initialize
             *
             * @private
             */
            _init: function() {
                $('body').on('click', this.option('favoriteAddButtonSelector'), $.proxy(this._onFavoriteAddButtonClick, this));
                $('body').on('click', this.option('favoriteRemoveButtonSelector'), $.proxy(this._onFavoriteRemoveButtonClick, this));
            },
            
            /**
             * update count
             */
            _updateCount: function() {
                this.requestHandler.send(this.option('countRoute'), {}, {}, {method: 'POST'});
            },

            /**
             * Initialize Loading Events
             *
             * @private
             */
            _initLoadingEvents: function() {
                // Requesthandler loading events
                this.requestHandler.on('success', $.proxy(this._onLoadSuccess, this));
                this.requestHandler.on('error', $.proxy(this._onLoadError, this));
            },

            /**
             * Click handler for adding favorite items
             * @param jQuery.Event event
             * @private
             */
            _onFavoriteAddButtonClick: function(event) {
                var elem = $(event.currentTarget);

                // Check if is already active
                if (elem.hasClass(this.option('buttonActiveClass'))){
                    return;
                }

                // Send ajax request
                this.requestHandler.send(this.option('addRoute'), {
                    item: elem.attr('data-fcse-favorites'),
                    timestamp: elem.attr('data-fcse-favorites-timestamp'),
                    key: elem.attr('data-fcse-favorites-key')
                }, {}, {method: 'POST'});

                // Update active class
                elem.addClass(this.option('buttonActiveClass'));
                elem.attr('data-fcse-role', 'favorites--remove');

                // Update label
                elem.find('[data-favorites-label-selected]').each(function(idx, labelElem){
                    $(labelElem).text($(labelElem).attr('data-favorites-label-selected'));
                });
            },

            /**
             * Click handler for removing favorite items
             * @param jQuery.Event event
             * @private
             */
            _onFavoriteRemoveButtonClick: function(event) {
                var elem = $(event.currentTarget);
                this.requestHandler.send(this.option('removeRoute'), {
                    item: elem.attr('data-fcse-favorites'),
                    timestamp: elem.attr('data-fcse-favorites-timestamp'),
                    key: elem.attr('data-fcse-favorites-key')
                }, {}, {method: 'POST'});

                // Remove item
                elem.closest('[data-fcse-role="favorites-item"]').fadeOut(300, function() { $(this).remove(); });
                elem.removeClass(this.option('buttonActiveClass'));
                elem.attr('data-fcse-role', 'favorites--add');

                // Decrease counter
                var count = $(this.option('favoriteCountSelector'));
                var itemCount = Math.max(parseInt(count.first().text()) - 1, 0);
                count.text(itemCount);

                // Update label
                elem.find('[data-favorites-label-unselected]').each(function(idx, labelElem){
                    $(labelElem).text($(labelElem).attr('data-favorites-label-unselected'));
                });

                this.dispatchEvent('remove', itemCount);
                return;
            },

            /**
             * Loads the content of the offerlist
             *
             * @private
             */
            _loadContent: function(routeName, additionalParams, additionalRouteParams){
                // Merge Parameters
                var params = $.extend(this.scope.getQuery(), additionalParams || {});

                // Send request
                this.requestHandler.cancel(this.option(routeName));
                this.requestHandler.send(this.option(routeName), params, routeparams);
            },

            /**
             * Handler for loading success
             *
             * @param event
             * @param data
             * @private
             */
            _onLoadSuccess: function(event, data){
                var count = $(this.option('favoriteCountSelector'));
                if (data.route === this.option('countRoute')){
                    count.text(event.meta.count);
                }
               // Success handling for adding item
                if (data.route === this.option('addRoute')){
                    var itemCount = parseInt(count.first().text()) + 1;
                    count.text(itemCount);
                    this.dispatchEvent('add', itemCount);
                    return;
                }

                // Success handling for removing item
                if (data.route !== this.option('removeRoute')){
                    return;
                }
            },

            /**
             * Handler for content loading error
             *
             * @param event
             * @private
             */
            _onLoadError: function(event){

            }
        });

        return FavoritesHandler;
    }
);


// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/favoriteshandler/favoritesHandler.js